import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultInterceptorChainClass;
function DefaultInterceptorChain() {
  if (DefaultInterceptorChainClass === VOID) {
    class $ {
      constructor(interceptors, index) {
        this.s64_1 = interceptors;
        this.t64_1 = index;
      }
      u64(request) {
        // Inline function 'kotlin.check' call
        if (!(this.t64_1 < this.s64_1.v2())) {
          throw IllegalStateException().o('Check failed.');
        }
        return this.s64_1.w2(this.t64_1).v64(request, new (DefaultInterceptorChain())(this.s64_1, this.t64_1 + 1 | 0));
      }
    }
    initMetadataForClass($, 'DefaultInterceptorChain');
    DefaultInterceptorChainClass = $;
  }
  return DefaultInterceptorChainClass;
}
//region block: exports
export {
  DefaultInterceptorChain as DefaultInterceptorChain10weji0clzo5q,
};
//endregion

//# sourceMappingURL=ApolloInterceptor.mjs.map
